import { NavLink } from "react-router";
import { motion } from "framer-motion";
import { services } from "../../data/services";
import { useSEO } from "../../hooks/useSEO";

export default function ServicesPage(): JSX.Element {
  useSEO({
    title: "Our Services | Sports Medicine & Rehabilitation in Chennai",
    description: "Explore our specialized sports medicine services, including shoulder, knee, back, and neck care, PRP therapy, and targeted sports rehabilitation.",
    keywords: "sports medicine services, shoulder pain treatment chennai, knee rehab, sports physiotherapy, PRP therapy anna nagar"
  });

  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <motion.h1
        className="text-4xl font-bold text-center text-indigo-600 mb-12"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Our Services
      </motion.h1>

      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((service, index) => (
          <motion.div
            key={service.slug}
            className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-shadow"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
          >
            <NavLink to={`/service-details/${service.slug}`}>
              <div className="relative">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-56 object-cover"
                />
                <div className="absolute inset-0 bg-black/30 hover:bg-black/40 transition" />
              </div>
              <div className="p-5">
                <h2 className="text-xl font-semibold text-indigo-600 mb-2">
                  {service.title}
                </h2>
                <p className="text-gray-600 line-clamp-3">
                  {service.description}
                </p>
                <span className="mt-3 inline-block text-indigo-500 font-medium hover:underline">
                  Learn More 
                </span>
              </div>
            </NavLink>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
